export default "__VITE_ASSET___WKFnd7I__"